module.exports = __webpack_public_path__ + "static/mobile-wasabi-362cbee8816bd8dc4ef33c257a3e9f13.png";